<div class="row">
  <div class="col-md-12 popin-container space-between">
    <div class="customerBox">
      <mat-icon class="icon valign-customer" matTooltip="Société" matSuffix>apartment</mat-icon>
      <strong class="customerIdentity">{{ customerName }}</strong>
      <a routerLink="/{{ visitRandomId }}/{{ uri }}/edit" class="float-right"><strong>Ce n'est pas moi</strong></a><br>
      {{ customerActivity }} à {{ customerCity }}
    </div>
    <div class="text-center">
      <h3>Afin que nous puissions vous contacter rapidement, indiquez nous quel produit est concernée par votre demande d'assistance.</h3>
    </div>
    <div class="buttonsBox">
      <a routerLink="{{ productList[1].id }}?visitRandomId={{ visitRandomId }}"><button type="button" class="btn btn-primary m-2">{{ productList[1].name}}</button></a>
      <a routerLink="{{ productList[2].id }}?visitRandomId={{ visitRandomId }}" *ngIf="productList[2].id"><button type="button" class="btn btn-primary m-2">{{ productList[2].name}}</button></a>
      <a routerLink="{{ productList[3].id }}?visitRandomId={{ visitRandomId }}" *ngIf="productList[3].id"><button type="button" class="btn btn-primary m-2">{{ productList[3].name}}</button></a>
    </div>
  </div>
</div>
